import { TableColumn } from '@/typing';
import { slotList } from '@/components/page-model/mjstore/mjstore-customer-config';
import {get_gender, get_is_active, get_is_active2, getDate} from '@/utils/function';
export default (current_org: any) => {
  const None = null;
  const True = true;
  const False = false;
  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '会员编号',
      width: 150,
      dataIndex: 'code',
      checked: true,
    },
    {
      title: '会员姓名',
      width: 150,
      dataIndex: 'name',
      checked: true,
    },
    {
      title: '会籍门店',
      width: 150,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '所属顾问',
      width: 150,
      dataIndex: 'adviser__name',
      checked: true,
    },
    {
      title: '等级名称',
      width: 80,
      dataIndex: 'grade__name',
      checked: true,
    },
    {
      title: '性别',
      width: 80,
      dataIndex: 'gender',
      checked: true,
      content: (record: any, text: any) => {
        return get_gender(text);
      },
      filterMultiple: true,
      filters: [
        { text: '全部', value: '' },
        { text: '女', value: 0 },
        { text: '男', value: 1 },
      ],
    },
    {
      title: '电话',
      dataIndex: 'phone',
      width: 180,
      checked: true,
    },
    {
      title: '生日',
      dataIndex: 'birthday',
      checked: true,
      width: 180,

      content: (record: any, text: any) => {
        return getDate(text);
      },
    },
    {
      title: '建档日期',
      dataIndex: 'join_date',
      checked: true,
      width: 150,

      content: (record: any, text: any) => {
        return getDate(text);
      },
    },
    {
      title: '获客方式',
      dataIndex: 'hk_type__name',
      width: 110,
      checked: true,
    },
    {
      title: '微信昵称',
      dataIndex: 'persontocostom__name',
      width: 110,
      content: (record: any, text: any) => {
        return record.persontocostom__person_id ? (text ? text : '已绑定') : '未绑定';
      },
      checked: true,
    },
    {
      title: '数据核对',
      dataIndex: 'is_checked',
      width: 110,
      cellComponent: 'boolean',
      name1: '已完成',
      name2: '',
      checked: true,
      content: (record: any, text: any) => {
        return text ? '已完成' : '';
      },
    },
    {
      title: '操作',
      width: 170,
      dataIndex: 'is_active',
      checked: true,
      cellComponent: 'action',
      fixed: 'right',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '可用', value: true },
        { text: '作废', value: false },
      ],
      content: (record: any, text: any) => {
        return get_is_active2(text);
      },
    },
  ];

  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push(
    { type: 'custom', slotName: 'gender', field_0: '女', field_1: '男' },
    { type: 'custom', field_true: '可用', field_false: '作废' },
    {
      type: 'custom',
      slotName: 'is_checked',
      field_true: '已完成',
      field_false: '',
    },
  );

  return {
    baseColumns: baseColumns,
    newSlotList: newSlotList,
  };
};
